import  { useEffect, useState } from 'react'



export default function useQuerySearch(config: {
    timeout?: number
    sendQuery?: (query: string | null) => void
    setIsLoading?: (isLoading: boolean) => void
    valueInit?: string | null
    onChangeCallback?: (query: string) => void
}) {
    const {timeout = 1000, sendQuery, setIsLoading, valueInit, onChangeCallback} = config
    const [query, setQuery] = useState<string | null>(valueInit || null);

    const [readyToSearch, setReadyToSearch] = useState(false);
  
    const minLenghtQuery = 0;
  
    useEffect(() => {
      if (valueInit) {
        setQuery(valueInit);
        sendQuery && sendQuery(query);
      }
    }, [valueInit]); // eslint-disable-line

    useEffect(() => {
      if (readyToSearch && sendQuery) {
        sendQuery(query);
        (setIsLoading && setIsLoading(false));
      }
    }, [readyToSearch]); // eslint-disable-line
  
  
    const onSetQuery = (query: string) => {
      setQuery(query);
    onChangeCallback && onChangeCallback(query);
      


  
      if (String(query).length >= minLenghtQuery) {
        setReadyToSearch(false);
        setTimeout(() => {
          setReadyToSearch(true);
        }, timeout);
      }
  
      (setIsLoading &&  setIsLoading(true));
      if (readyToSearch) {
        setReadyToSearch(false);
  
        setTimeout(() => {
          setReadyToSearch(true);
          (setIsLoading && setIsLoading(false));
        }, timeout);
      }
    };
  return {
    setQuery : onSetQuery,
    valueQuery: query,

  } 
}
